var productName = 'calendar';import Combo from '../../../../Core/widget/Combo.js';
/**
 * @module Scheduler/view/recurrence/field/RecurrenceFrequencyCombo
 */
/**
 * A combobox field allowing to pick frequency in the {@link Scheduler.view.recurrence.RecurrenceEditor recurrence dialog}.
 *
 * @extends Core/widget/Combo
 * @classType recurrencefrequencycombo
 */
export default class RecurrenceFrequencyCombo extends Combo {
    static get $name() {
        return 'RecurrenceFrequencyCombo';
    }
    // Factoryable type name
    static get type() {
        return 'recurrencefrequencycombo';
    }
    static get defaultConfig() {
        return {
            editable              : false,
            displayField          : 'text',
            valueField            : 'value',
            localizeDisplayFields : true
        };
    }
    buildItems() {
        return [
            { value : 'DAILY',   text : 'L{Daily}' },
            { value : 'WEEKLY',  text : 'L{Weekly}' },
            { value : 'MONTHLY', text : 'L{Monthly}' },
            { value : 'YEARLY',  text : 'L{Yearly}' }
        ];
    }
};
// Register this widget type with its Factory
RecurrenceFrequencyCombo.initClass();
RecurrenceFrequencyCombo._$name = 'RecurrenceFrequencyCombo';